// src/constants/amenidades.js
import {
    FaSwimmer,
    FaDumbbell,
    FaBirthdayCake,
    FaTree,
    FaGamepad,
    FaDog,
    FaHome,
    FaParking,
    FaFutbol,
    FaUtensils,
    FaTableTennis,
    FaLaptop,
    FaFireAlt,
    FaChild,
    FaGlassCheers,
} from 'react-icons/fa';

export const AMENITIES_CATALOG = [
    {
        id: 'alberca',
        name: 'Alberca',
        type: 'reservable',
        Icon: FaSwimmer,
    },
    {
        id: 'gimnasio',
        name: 'Gimnasio/Zona FIT',
        type: 'reservable',
        Icon: FaDumbbell,
    },
    {
        id: 'salon',
        name: 'Salón de Eventos/Palapa',
        type: 'reservable',
        Icon: FaBirthdayCake,
    },
    {
        id: 'zona_deportes',
        name: 'Zona de Deportes/Recreación',
        type: 'reservable',
        Icon: FaFutbol,
    },
    {
        id: 'asadores',
        name: 'Asadores / Zona BBQ / Pérgolas Asador',
        type: 'reservable',
        Icon: FaUtensils,
    },
    {
        id: 'cancha_padel',
        name: 'Cancha de Pádel',
        type: 'reservable',
        Icon: FaTableTennis,
    },
    {
        id: 'coworking',
        name: 'Coworking / Business Center / Sala de Juntas',
        type: 'reservable',
        Icon: FaLaptop,
    },
    {
        id: 'fogatero',
        name: 'Fogatero / Fire Pit / Terraza Lounge Nocturna',
        type: 'reservable',
        Icon: FaFireAlt,
    },
    {
        id: 'ludoteca',
        name: 'Ludoteca / Kids Club (Interior)',
        type: 'reservable',
        Icon: FaChild,
    },
    {
        id: 'roof_top',
        name: 'Roof Top / Terraza Mirador',
        type: 'reservable',
        Icon: FaGlassCheers,
    },
    {
        id: 'areas_verdes',
        name: 'Áreas Verdes',
        type: 'reservable',
        Icon: FaTree,
    },
    {
        id: 'zona_juegos',
        name: 'Zona de Juegos',
        type: 'reservable',
        Icon: FaGamepad,
    },
    {
        id: 'area_mascotas',
        name: 'Área de Mascotas',
        type: 'reservable',
        Icon: FaDog,
    },
    {
        id: 'casa_club',
        name: 'Casa Club',
        type: 'reservable',
        Icon: FaHome,
    },
    {
        id: 'estacionamiento',
        name: 'Estacionamiento',
        type: 'reservable',
        Icon: FaParking,
    },
];
